import {isFeatureEnabled} from '@github-ui/feature-flags'
import getFetchNonce from '@github-ui/fetch-nonce'
import {ssrSafeWindow} from '@github-ui/ssr-utils'

const globalFetch = fetch

export default function applyFetchPatch() {
  if (ssrSafeWindow && isFeatureEnabled('fetch_patch')) {
    const nonce = getFetchNonce()

    ssrSafeWindow.fetch = async (input: string | URL | Request, init?: RequestInit) => {
      if (shouldPatchFetch(input)) {
        return fetchWithNonce(input, init, nonce)
      }

      return globalFetch(input, init)
    }
  }
}

function shouldPatchFetch(input: string | URL | Request) {
  if (!isFeatureEnabled('fetch_patch')) return false

  let url: URL
  if (input instanceof Request) {
    url = new URL(input.url, window.location.origin)
  } else if (input instanceof URL) {
    url = input
  } else {
    url = new URL(input.toString(), window.location.origin)
  }

  return url.origin === window.location.origin
}

function fetchWithNonce(input: string | URL | Request, init: RequestInit | undefined, nonce: string) {
  if (input instanceof Request) {
    input.headers.set('X-Fetch-Nonce', nonce)
    return globalFetch(input, init)
  }

  if (!init) {
    return globalFetch(input, {
      headers: {
        'X-Fetch-Nonce': nonce,
      },
    })
  }

  const newHeaders = new Headers(init.headers)
  newHeaders.set('X-Fetch-Nonce', nonce)
  init.headers = newHeaders

  return globalFetch(input, init)
}
